import * as z from 'zod/v4'

import {buildEntrySchemaFor} from '../entry'
import {buildPageSchemaForTemplate} from './containerPage'
import {PrimerComponentHeroSchema} from './primerComponentHero'

export const TemplateCategorySchema = buildEntrySchemaFor('templateCategory', {
  fields: z.lazy(() =>
    z.object({
      hero: PrimerComponentHeroSchema,
    }),
  ),
})

export const CategoryPageSchema = buildPageSchemaForTemplate(TemplateCategorySchema)
export type CategoryPage = z.infer<typeof CategoryPageSchema>
